module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-BoldItalic-WebS-a33e4eac75db008e3851e321d19654e6.woff2";